import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { TagProductsView } from './TagProductsView'


export const TagProducts = () => {
    const [products, setProducts] = useState()
    const [loading, setLoading] = useState(true)
    const [brands, setBrands] = useState()
    const [suppliers, setSuppliers] = useState()
    const [categories, setCategories] = useState()

    useEffect(() => {
        axios.get(process.env.REACT_APP_HOST + 'api/reports/getProductsToTag')
            .then((res) => {
                setBrands(res.data.brands)
                setSuppliers(res.data.suppliers)
                setCategories(res.data.categories)
                setProducts(res.data.products)
                return res.data.products
            }).then((data) => {
                //filter so only shows top level parent products, avoids duplication in tagging
                const arr = []
                const results = data.filter((product) => {
                    if (!arr.includes(product.parentId) || product.parentId === '') {
                        arr.push(product.parentId)
                        return product
                    }

                })
                setProducts(results.map(product => ({ ...product, status: 'Save' }))); // Adding status field
                setLoading(false)

            })

    }, [])

    const updateProductStatus = (productId, status) => {
        setProducts(prevProducts => prevProducts.map(product => {
            if (product.id === productId) {
                return { ...product, status }; // Update only the specific product
            }
            return product;
        }));
    }


    const onClickSubmit = async (row, callback) => {
        try {
            const res = await axios.post(process.env.REACT_APP_HOST + 'api/reports/update', {
                params: { product: row },
            });
            updateProductStatus(row.id, 'Saved'); // Updating status of specific product
            setTimeout(() => updateProductStatus(row.id, 'Save'), 3000); // Resetting status after 3 seconds
        } catch(err) {
            console.log(err);
        }
    }
    return <TagProductsView
            loading={loading}
            products={products}
            brands={brands}
            suppliers={suppliers}
            categories={categories}
            onClickSubmit={onClickSubmit}
            updateProductStatus={updateProductStatus}
        />
    }
